import { render, staticRenderFns } from "./FactoriesListPage.vue?vue&type=template&id=617da2cc&scoped=true&"
import script from "./FactoriesListPage.vue?vue&type=script&lang=ts&"
export * from "./FactoriesListPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoriesListPage.vue?vue&type=style&index=0&id=617da2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617da2cc",
  null
  
)

export default component.exports